import { ThemeProvider, calculatePalette } from '@bizzabo/design-system';
import { RingSettings } from '@bizzabo/entities';

export type ThemeProviderCustomizationProps = {
    customization?: RingSettings['customization'];
};

const MeetingSettingsModalThemeProvider: React.FC<ThemeProviderCustomizationProps> = ({
    children,
}) => {
    const theme = {};
    const customPalette = calculatePalette({
        backgroundColor: 'white',
        surfaceColor: '#FFFFFF',
        interactiveColor: '#404040',
    });

    return (
        <ThemeProvider customization={customPalette} customTheme={theme}>
            {children}
        </ThemeProvider>
    );
};

export default MeetingSettingsModalThemeProvider;
